module.exports = __webpack_public_path__ + "img/6e1c3dc.png";